import { taxClassToIvaRate } from '../../catalog/domain-api'
import type { ProductIvaRate } from '../../catalog/domain-api';

export type PurchaseTaxRegime = 'monotributo' | 'responsable_inscripto';

export type PurchaseLineCostSplit = {
  unitCostGross: number;
  unitCostNet: number;
  ivaAmountUnit: number;
  ivaRate: ProductIvaRate;
};

export function round2(n: number): number {
  return Math.round(n * 100) / 100;
}

export function ivaRatePercent(rate: ProductIvaRate): number {
  if (rate === '21') return 0.21;
  if (rate === '10.5') return 0.105;
  return 0;
}

/** Monotributo tipea bruto; RI tipea neto. Gasto siempre usa bruto; stock usa neto si RI. */
export function splitPurchaseUnitCost(params: {
  enteredUnitCost: number;
  taxClass?: string | null;
  regime: PurchaseTaxRegime;
}): PurchaseLineCostSplit {
  const ivaRate = taxClassToIvaRate(params.taxClass);
  const rate = ivaRatePercent(ivaRate);
  const entered = Number.isFinite(params.enteredUnitCost) ? params.enteredUnitCost : 0;

  if (params.regime === 'responsable_inscripto') {
    const unitCostNet = round2(entered);
    const ivaAmountUnit = round2(unitCostNet * rate);
    return {
      unitCostNet,
      unitCostGross: round2(unitCostNet + ivaAmountUnit),
      ivaAmountUnit,
      ivaRate,
    };
  }

  const unitCostGross = round2(entered);
  const unitCostNet = rate > 0 ? round2(unitCostGross / (1 + rate)) : unitCostGross;
  return {
    unitCostGross,
    unitCostNet,
    ivaAmountUnit: round2(unitCostGross - unitCostNet),
    ivaRate,
  };
}

export function stockUnitCostForRegime(
  split: PurchaseLineCostSplit,
  regime: PurchaseTaxRegime,
): number {
  return regime === 'responsable_inscripto' ? split.unitCostNet : split.unitCostGross;
}
